
export const environment = {
  firebase: {
    projectId: 'mace-80d59',
    appId: '1:535252366267:web:c4c21b388117e803920a9e',
    storageBucket: 'mace-80d59.appspot.com',
    apiKey: 'AIzaSyDDUuL1N9bcwNE4MNU7cm4AyHp2dnFl4AA',
    authDomain: 'mace-80d59.firebaseapp.com',
    messagingSenderId: '535252366267',
  },

      production: false
    };
    